export default "__VITE_ASSET__27a739a4__"